import { useEffect, useState } from "react";
import { DollarSign, ShoppingCart, CalendarCheck, Package, Users, Mail, Crown } from "lucide-react";
import api from "@/lib/api";

const CARDS = [
    { key: "revenue", label: "Revenue (paid)", icon: DollarSign, prefix: "$" },
    { key: "orders", label: "Orders", icon: ShoppingCart },
    { key: "bookings", label: "Bookings", icon: CalendarCheck },
    { key: "products", label: "Products", icon: Package },
    { key: "members", label: "Members", icon: Users },
    { key: "active_memberships", label: "Active Memberships", icon: Crown },
    { key: "subscribers", label: "Subscribers", icon: Mail },
];

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

    return (
        <div>
            <h1 className="font-serif text-4xl text-cream">Dashboard</h1>
            <p className="text-ash mt-1">An overview of Sherrie's practice.</p>
            <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-stats">
                {CARDS.map((c) => (
                    <div key={c.key} className="p-6 rounded-2xl bg-surface border border-gold/10">
                        <c.icon className="w-5 h-5 text-gold mb-3" />
                        <div className="text-3xl font-serif text-cream">{c.prefix || ""}{stats ? stats[c.key] : "-"}</div>
                        <div className="text-xs text-ash mt-1">{c.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
